import { Container, DesignSystem } from "@wearewqa/wqa-design-system";
import "./scss/main.scss";
import React from "react";
import { Layout } from "./components";
import { AuthProvider } from "./hooks/auth.provider";
import AppRoutes from "./routes/AppRoutes";

function App() {
  return (
    <DesignSystem>
      <AuthProvider>
        <Layout>
          <Container>
            <AppRoutes />
          </Container>
        </Layout>
      </AuthProvider>
    </DesignSystem>
  );
}

export default App;
